<template>
  <ElConfigProvider :locale="locale" :size="settingStore.getElementPlusSize">
    <RouterView />
  </ElConfigProvider>
</template>

<script setup>
  import { useSettingStore } from '@/store/modules'
  import zhCn from 'element-plus/es/locale/lang/zh-cn'
  import { getFingerprint } from '@/utils/fingerprint'
  import { ElConfigProvider } from 'element-plus'
  import { useDevice } from '@/hooks/useDevice'
  import { onMounted } from 'vue'


  // 注册页面宽度变化
  useDevice()
  const locale = computed(() => zhCn)
  const settingStore = useSettingStore()

  onMounted(async () => {
    settingStore.initSetting()
    // 获取设备id
    const storedId = localStorage.getItem('deviceId');
    if (!storedId) {
      const newId = await getFingerprint();
      localStorage.setItem('deviceId', newId);
    } else {
    }
  })
</script>
